module.exports = __webpack_public_path__ + "h5/img/tabvip1.ea246cb0.png";